import TaskStatusValueDisplay from './TaskStatusValueDisplay';
import TaskStatusEditor from './TaskStatusEditor';
import TaskStatusDesigner from './TaskStatusDesigner';

const TaskStatus = {
  // Sub-components
  designer: TaskStatusDesigner,
  display: TaskStatusValueDisplay,
  editor: TaskStatusEditor,

  // Gets value of property - used for comparison purposes by multi-edit
  getPropValue(elementProp) {
    // console.log('elementProp, typeOptions: ', elementProp, typeOptions);
    const prop = elementProp.toJSON();
    const { status, reason, startDate, finishDate } = prop;
    if (!status || status === 'Not Started') return { status: 'Not Started', startDate };
    if (status === 'In Progress') return { status, startDate };
    if (status === 'Finished') return { status, startDate, finishDate };
    if (status === 'Blocked') return { status, startDate, reason };
    return undefined;
  },

};

export default TaskStatus;



// WEBPACK FOOTER //
// ./src/components/types/TaskStatus/TaskStatus.js